import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet } from '../../lib/api';
import { buildAdminAuthHeaders, isUnauthorizedAdminError } from './admin-utils';

export default function useAdminOrders(path, parameters, adminToken, handleUnauthorized) {
  const [orders, setOrders] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState('');
  const requestRef = useRef(0);
  const load = useCallback(async (cursor = null) => {
    if (!adminToken) return;
    const request = ++requestRef.current;
    setError('');
    if (cursor) setLoadingMore(true); else setLoading(true);
    try {
      const params = new URLSearchParams(parameters);
      params.set('limit', '30');
      if (cursor) params.set('cursor', cursor);
      const payload = await apiGet(`${path}?${params}`, { headers: buildAdminAuthHeaders(adminToken) });
      if (request !== requestRef.current) return;
      const records = Array.isArray(payload?.orders) ? payload.orders : [];
      setOrders(current => cursor ? [...new Map([...current, ...records].map(order => [order.id, order])).values()] : records);
      setNextCursor(payload.nextCursor || null);
    } catch (err) {
      if (request !== requestRef.current) return;
      if (isUnauthorizedAdminError(err)) handleUnauthorized();
      else setError(err.message || 'Caricamento ordini non riuscito.');
    } finally {
      if (request === requestRef.current) { setLoading(false); setLoadingMore(false); }
    }
  }, [path, parameters, adminToken, handleUnauthorized]);
  useEffect(() => {
    setOrders([]);
    setNextCursor(null);
    setLoadingMore(false);
    load();
    return () => { requestRef.current += 1; };
  }, [load]);
  return { orders, setOrders, nextCursor, loading, loadingMore, error, setError, load };
}
